<template>
  <div v-if="list && list.length > 0" class="w-full">
    <van-notice-bar scrollable color="#fff" background="#2222">
      <span
        class="mr-[10px]"
        v-for="(item, index) in list"
        :key="index"
        @click="hanelClick(item)"
        >{{ item.title }}</span
      >
    </van-notice-bar>
  </div>
</template>

<script setup>
import { ref } from 'vue'
defineProps({
  list: {
    type: Array,
    default: () => []
  }
})
const hanelClick = (item) => {
  if (item.href) {
    window.open(item.href, '_blank')
  }
}
</script>

<style></style>
